



























































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { showErrors } from '@/utils/snack'
import AppDialog from '@/components/AppDialog.vue'
import DocuSignDialog from '@/modules/Policy/components/DocuSignDialog.vue'
import { dateToDisplay } from '@/utils/dateTime'
import {
  docuSignStatus,
  docuSignStatusKeys,
  docuSignStatusValues
} from '../helpers/docuSign'
import { getDocusignEnvelopes } from '@/modules/Envelop/gql/envelop.gql'
@Component({
  components: {
    AppDialog,
    DocuSignDialog
  }
})
export default class PolicyDetailDocuSign extends mixins(DocuSignDialog) {
  dateToDisplay = dateToDisplay;
  docuSignStatus = docuSignStatus;
  envelopList: { [k: string]: any } = [];
  tableColumn = [
    {
      field: 'id',
      title: 'ID',
      width: 60
    },
    {
      field: 'subject',
      title: 'Envelope Name',
      slots: { default: 'subject' }
    },
    {
      field: 'client',
      title: 'Client',
      slots: { default: 'client' }
    },
    {
      field: 'clientName',
      title: 'Client Name'
    },
    {
      field: 'clientEmail',
      title: 'Email'
    },
    {
      field: 'createdAt',
      title: 'Date',
      slots: { default: 'createdAt' }
    },
    {
      field: 'createdBy.username',
      title: 'Creator'
    },
    {
      field: 'status',
      title: 'Status',
      slots: { default: 'status' }
    }
  ];
  loading = false;
  docuSignDialog = {
    show: false,
    title: 'DocuSign',
    disable: false
  };

  mounted () {
    this.getEnvelopList()
  }

  // 获取信封数据
  async getEnvelopList () {
    this.loading = true
    try {
      const result = await this.$apollo.query({
        query: getDocusignEnvelopes,
        variables: {
          masterType: 'POLICY',
          masterId: +this.policy.id
        }
      })
      this.envelopList = result.data.getDocusignEnvelopes
      this.loading = false
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  // 跳转信封详情页
  routeToDetail (item: any, routeName: string, type: string) {
    this.$router.push({
      name: routeName,
      params: {
        id: item.id + '',
        masterId: this.policy.id + '',
        masterType: 'policy',
        type
      }
    })
  }

  clickCell (data: any) {
    this.routeToDetail(
      data.row,
      'EnvelopDetail',
      data.row.status !== 'draft' ? 'detail' : 'edit'
    )
  }

  showDocuSignDialog () {
    this.docuSignDialog.show = true
  }

  hideDocuSignDialog () {
    this.docuSignDialog.show = false
  }
}
